export default function phoneFormat(value) {
  try {
    if (!value.trim()) {
      reject()
    }
    const regex = /(\d*)(\d{3})(\d{3})(\d{2})(\d{2})$/gs,
          digits = value.split(/\D/).join('').trim(),
          parseValue = digits.replace(regex, '$1 $2 $3-$4-$5')
    return parseValue.search(/^8 /) === 0 ? parseValue : `+${parseValue}`
  } catch (e) {
    return value
  }
}
